import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private _httpClient: HttpClient,) {
  }

  post(url: string, data: any): Observable<any> {

    return this._httpClient.post(this.urlApiConfig + url, data);
  }

  patch(url: string, data: any): Observable<any> {

    return this._httpClient.post(this.urlApiConfig + url, data);
  }

  put(url: string, data: any): Observable<any> {

    return this._httpClient.put(this.urlApiConfig + url, data);
  }

  get(url: string, options?: any): Observable<any> {
    return this._httpClient.get(this.urlApiConfig + url, options);
  }
  getParam(url: string, { httpParams }: { httpParams: HttpParams }): Observable<any> {
    return this._httpClient.get(this.urlApiConfig + url, { responseType: 'json', reportProgress: true, params: httpParams });
  }
  get2(url: string): Observable<any> {
    return this._httpClient.get(this.urlApiConfig + url, { responseType: 'blob', reportProgress: true });
  }

  getUrl(url: string, token: string): string {
    return this.urlApiConfig + url + '&token=' + token;
  }

  delete(url: string, options?: any): Observable<any> {
    return this._httpClient.delete(this.urlApiConfig + url, options);
  }

  post2(url: string, data: any): Observable<any> {
    console.log(url)
    return this._httpClient.post(this.urlApiConfig + url, data, { responseType: 'blob', reportProgress: true });
  }

  post3(url: string, data: any, options: any): Observable<any> {
    console.log(url)
    console.log(data)
    return this._httpClient.post(this.urlApiConfig + url, data, options);
  }

  post4(url: string, data: any): Observable<any> {
    console.log(url)
    return this._httpClient.post(this.urlApiConfig + url, data);
  }


  get urlApiConfig(): string {
    return environment.urlApi;
  }

}
